<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      permanent
      width="280"
      expand-on-hover
      style="position: absolute; z-index: 1;"
      miniVariantWidth="87"
    >
      <div class="top-bar">
        <div class="top-bar__head">
          <div class="top-bar__logo">
            <img width="100%" height="100%" src="@/assets/logo360.svg">
          </div>
        </div>

        <div class="avatar-root">
          <div class="avatar-root__info">
            <div class="avatar-root__name">{{ profile.full_name }}</div>
            <div class="avatar-root__email">{{ profile.email }}</div>
          </div>
        </div>
      </div>

      <v-list dense nav>
        <v-list-item link :to="{name: 'cpanel.dashboard'}">
          <v-list-item-icon>
            <v-icon>mdi-radar</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{name: 'cpanel.tours'}">
          <v-list-item-icon>
            <v-icon>mdi-camera-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>My Tours</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main style="padding-left: 87px">
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'default',
  computed: {
    ...mapGetters({
      profile: 'auth/profile'
    })
  },
  data: () => ({
    drawer: true,
    mini: false
  })
}
</script>

<style lang="scss">
.v-navigation-drawer {

  .top-bar {
    padding: 24px 20px 16px;

    &__head {
      display: flex;
      justify-content: space-between;
      margin-bottom: 25px;
    }

    &__logo {
      width: 32px;
    }
  }

  .avatar-root {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    border-radius: 12px;
    background-color: rgba(145, 158, 171, 0.12);

    &__name {
      font-weight: 500;
    }

    &__email {
      color: rgb(99, 115, 129);
    }
  }

  &--mini-variant {
    .v-list-item__icon {
      &:first-child {
        margin-right: 0 !important;
      }
    }

    .top-bar__logo {
      width: 47px;
    }

    .top-bar__mini {
      display: none;
    }

    .avatar-root {
      padding: 0px 4px;
      background-color: unset;

      &__name, &__email {
        display: none;
      }
    }
  }

  &__border {
    background-color: unset !important;
    border-right: 1px dashed rgba(145, 158, 171, 0.24);
  }

  .v-list {
    padding: 16px;
  }

  .v-list-item {
    padding: 3px 12px 3px 16px;
    user-select: none;
    border-radius: 8px;

    &:before {
      border-radius: 8px;
      background-color: unset;
    }

    &:hover {
      text-decoration: none;
      background-color: #f7f7f8;
    }

    &--active {
      color: rgb(155, 191, 51);
      background-color: rgba(37, 171, 0, 0.08);

      &:hover {
        text-decoration: none;
        background-color: #f7f7f8;
      }

      .v-list-item__title {
        font-weight: 500;
        color: rgb(155, 191, 51);
      }
    }

    .v-ripple__container {
      border-radius: 8px !important;
    }

    &__title {
      line-height: 1.57143;
      font-size: 1rem !important;
      font-family: "Public Sans", sans-serif;
      font-weight: 400;
      text-transform: capitalize;
      color: rgb(99, 115, 129);
    }

    &__icon {
      &:first-child {
        margin-right: 10px;
      }

      .v-icon {
        font-size: 22px;
      }
    }
  }
}
</style>
